<template>
  <div>
    <div>
      <span>{{tariffName}}, </span>
      <span class="ml-2">{{$t('message.tariff.freePayments', {count: tariffParams['limit']})}}</span>
    </div>
    <div>
      <span>{{$t('message.tariff.overLimit', {price: tariffParams['overPrice']})}}</span>
    </div>
    <div>
      <span>{{$t('message.tariff.overLimitAfter', {price: tariffParams['notWorkOverPrice']})}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TariffRtjs',
  computed: {
    ...mapGetters('payment', ['getPaymentType']),
    ...mapGetters('utils', ['getTariffName', 'getCurrentParams']),
    tariffName () {
      return this.getTariffName
    },
    tariffParams () {
      return this.getCurrentParams(this.getPaymentType)
    }
  }
}
</script>

<style scoped>

</style>
